module.exports = __webpack_public_path__ + "img/icon-edit.1a27ee08.svg";